export class SidebarConfigsService {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
        this.items = [];
    }
    async getMenuItems(template) {
        switch (template) {
            //Old FAQ
            case 'faq':
                this.items = [
                    {
                        title: await this.$translate('modules.application.detail.templates.faq.knowledgeBase'),
                        state: 'index',
                    },
                    {
                        title: await this.$translate('modules.application.detail.templates.faq.unknownQuestions'),
                        state: 'unknownQuestions',
                    },
                ];
                break;
            //New FAQ
            case 'faq2':
                this.items = [
                    {
                        title: await this.$translate('modules.application.detail.templates.faq2.scoreTitle'),
                        state: 'index',
                    },
                    {
                        title: await this.$translate('modules.application.detail.templates.faq2.feedbackTitle'),
                        state: 'feedback',
                    },
                ];
                break;
            //Bot Master
            case 'master':
                this.items = [
                    {
                        title: await this.$translate('master.title'),
                        state: 'index',
                    },
                ];
                break;
            //Bot AiAgent
            case 'aiAgent':
                this.items = [
                    {
                        title: 'AI Agent',
                        state: 'index',
                    },
                ];
                break;
            //Manual Attendance (operator)
            case 'operator':
                this.items = [
                    {
                        title: await this.$translate('modules.application.detail.templates.attendance.attendanceChannels'),
                        state: 'index',
                    },
                    {
                        title: await this.$translate('modules.application.detail.templates.attendance.automaticResponse'),
                        state: 'firstMessage',
                    },
                ];
                break;
            //Webhook
            case 'webhook':
                this.items = [
                    {
                        title: 'Webhook',
                        state: 'index',
                    },
                    {
                        title: 'BLiP Web',
                        state: 'index',
                        preventDefault: true,
                    },
                ];
                break;
            // SDK
            case 'undefined':
            default:
                this.items = [
                    {
                        title: await this.$translate('modules.application.detail.templates.api.credentials'),
                        state: 'index',
                    },
                    {
                        title: 'BLiP Web',
                        state: 'index',
                        preventDefault: true,
                    },
                ];
                break;
        }
        return this.items;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
SidebarConfigsService.$inject = ['$translate'];
